import * as d3 from 'd3'
import * as topojson from 'topojson'
const d3Identity = d3.geoIdentity().scale(.85).translate([0,-70])
const d3PathNy = d3.geoPath(d3Identity)
const colorCluster = d3.scaleSequential([1,9], d3.interpolateSpectral)
const zoom = d3.zoom()

export const drawTriState = props => {
    const { data, width, height } = props
    const chart = selection => {
        if (Array.isArray(data)){ return }
        const svg = selection.select('svg')
        const g = svg.select('g')//.attr('viewBox', polygons.bbox)
        g.selectAll('.map')
            .data(topojson.feature(data, data.objects.ny).features)
            .join('path')
            .attr('class','ny')
            .attr('fill', d => colorCluster(d.properties.CLUSTER))
            .attr('stroke', 'lightgrey')
            .attr('stroke-width', 0.5)
            .attr('stroke-linejoin','round')
            .attr('d', d3PathNy)
            .attr('id',d => `z-${d.properties.ZCTA5CE10}`)

        g.selectAll('.ct')
            .data(topojson.feature(data, data.objects.ct).features)
            .join('path')
            .attr('class', 'ct')
            .attr('fill', d => colorCluster(d.properties.CLUSTER))
            .attr('stroke', 'lightgrey')
            .attr('stroke-width', 0.5)
            .attr('stroke-linejoin','round')
            .attr('d', d3.geoPath(
                d3.geoIdentity()
                    .scale(0.2075)
                    .translate([width/1.3233,height/2.467])
            ))
            .attr('id',d => `z-${parseInt(d.properties.ZCTA5CE10)}`)

        g.selectAll('.nj')
            .data(topojson.feature(data, data.objects.nj).features)
            .join('path')
            .attr('class','nj')
            .attr('fill', d => colorCluster(d.properties.CLUSTER))
            .attr('stroke', 'lightgrey')
            .attr('stroke-width', 0.5)
            .attr('stroke-linejoin','round')
            .attr('d', d3.geoPath(
                d3.geoIdentity()
                    .scale(0.347)
                    .translate([width/2.35,height * .533])
            ))
            .attr('id',d => `z-${parseInt(d.properties.ZCTA5CE10)}`)

        zoom.on('zoom', zoomed)

        svg.call(zoom)

        function zoomed(evt) {
            const { transform } = evt
            // console.log(transform.k)
            // console.log(transform.k * .2, transform.k, transform.x, transform.y, transform.x / transform.y)
            g.attr('transform', transform )
            g.selectAll('path').attr('stroke-width', 1 / transform.k )
            g.selectAll('text').attr('font-size', transform.k / 10 )
        }
    }
    return chart
}

